jQuery(document).ready(function ($) {
    var nr_follow = $(".nr-follow").html();
    count = nr_follow;
    $(document).on('click', '.follow-btn', function (e) {
        var authorID = $(this).attr('data-authorID');
        var userID = $(this).attr('data-userID');
        var state = $(this).attr('data-state');
        var btn_name = $(this).text();

        if (state == "follow") {
            count++;
            $(this).html('Avfølg');
            $(".nr-follow").html(count);
            $(this).attr('data-state', 'unfollow');
            let data = {
                'action': 'follow_user',
                'data': {
                    "user_id": userID,
                    "author_id": authorID,
                }
            }
            $.ajax({
                type: 'POST',
                url: script_object.ajax_url,
                data: data,
                dataType: 'json'
            });
        }
        else if (state == "unfollow") {
            count--;
            $(this).html('Følg');
            $(".nr-follow").html(count);
            $(this).attr('data-state', 'follow');
            let data = {
                'action': 'unfollow_user',
                'data': {
                    "user_id": userID,
                    "author_id": authorID,
                }
            }
            $.ajax({
                type: 'POST',
                url: script_object.ajax_url,
                data: data,
                dataType: 'json'
            });
        }


    });
    var authorID = $('#dName').attr('data-authorID');
    $(document).on('click', '.unfollow_user', function (e) {
        e.preventDefault();
        var userID = $(this).attr('data-user_id'); 
        let data = {
            'action': 'unfollow_user_test',
            'data': {
                "user_id": userID,
                "author_id": authorID,
            }
        }
        $.ajax({
            type: 'POST',
            url: script_object.ajax_url,
            data: data,
            success: function(){
                location.reload();
            },
            dataType: 'json'
        });
    });
    $(document).on('click', '.follow-user-from-others-profile', function (e) {
        var authorID = $(this).attr('data-authorid');
        var userID = $(this).attr('data-userid');
        let data = {
            'action': 'follow_user',
            'data': {
                "user_id": userID,
                "author_id": authorID,
            }
        }
        $.ajax({
            type: 'POST',
            url: script_object.ajax_url,
            data: data,
            success: function(){
                location.reload();
            },
            dataType: 'json'
        });
        location.reload();
    });
    $('#btn-login-modal').click(function () {
        $('#login-register-modal').removeClass('show-register d-none');
        $('body').addClass('modal-active disable-scroll');
    });

    $('.search-followers').keyup(function () {
        let input = $(this).val();
        input = input.toLowerCase();
        let userName = document.getElementsByClassName('user-name');
        let followerCard = document.getElementsByClassName('follower-card');

        for (i = 0; i < userName.length; i++) {
            if (!userName[i].innerHTML.toLowerCase().includes(input)) {
                userName[i].style.display = "none";
                followerCard[i].setAttribute('style', 'display:none !important')
            }
            else {
                userName[i].style.display = "list-item";
                followerCard[i].setAttribute('style', 'display:flex !important')
            }
        }
    });

    let following = document.getElementById('follower-section');
    let tabListFollowing = document.getElementById('single-tab-following');
    let tabListFollowers = document.getElementById('single-tab-followers');
    
    if(tabListFollowing){
        tabListFollowing.addEventListener('click', function () {
            following.textContent = "Følger";
        })
    }
    
    if(tabListFollowers){
        tabListFollowers.addEventListener('click', function () {
            following.textContent = "Følgere";
        })
    }

});



